import { SecurityUtils } from './security';
import { AuthStorage } from '@/libs/device-auth/services/authService';
import { AuthTokens, UserSession } from '@/libs/device-auth/authTypes';
import { STORAGE_KEYS } from '@/utils/constants';

export class StorageService implements AuthStorage {
  private static instance: StorageService;

  static getInstance(): StorageService {
    if (!StorageService.instance) {
      StorageService.instance = new StorageService();
    }
    return StorageService.instance;
  }

  // SelectionStorage implementation
  async store(key: string, value: string): Promise<void> {
    await SecurityUtils.secureStore(key, value);
  }
  async retrieve(key: string): Promise<string | null> {
    return await SecurityUtils.secureRetrieve(key);
  }
  async remove(key: string): Promise<void> {
    await SecurityUtils.secureRemove(key);
  }

  // AuthStorage implementation
  async saveTokens(tokens: AuthTokens): Promise<void> {
    await SecurityUtils.secureStore(
      STORAGE_KEYS.AUTH_TOKENS,
      JSON.stringify(tokens),
    );
  }

  async getTokens(): Promise<AuthTokens | null> {
    const result = await SecurityUtils.secureRetrieve(STORAGE_KEYS.AUTH_TOKENS);
    return result ? JSON.parse(result) : null;
  }

  async saveSession(session: UserSession): Promise<void> {
    await SecurityUtils.secureStore(
      STORAGE_KEYS.USER_SESSION,
      JSON.stringify(session),
    );
  }

  async getSession(): Promise<UserSession | null> {
    const result = await SecurityUtils.secureRetrieve(
      STORAGE_KEYS.USER_SESSION,
    );
    return result ? JSON.parse(result) : null;
  }

  async clearAll(): Promise<void> {
    await SecurityUtils.secureRemove(STORAGE_KEYS.AUTH_TOKENS);
    await SecurityUtils.secureRemove(STORAGE_KEYS.USER_SESSION);
  }

  // SecurityService implementation
  isTokenExpired(expiresAt: number): boolean {
    return Date.now() >= expiresAt;
  }

  // Token refresh scheduling
  static scheduleTokenRefresh(
    expiresAt: number,
    refreshCallback: () => void,
  ): NodeJS.Timeout {
    const refreshTime = expiresAt - Date.now() - 5 * 60 * 1000; // 5 minutes before expiry
    return setTimeout(refreshCallback, Math.max(refreshTime, 0));
  }
}

export const storageSvc = StorageService.getInstance();
